import { ISVG } from "./UrlIcon";

export interface BackIconProps extends ISVG {}

export const BackIcon = ({ width, height }: BackIconProps) => {
    const _width = width ?? 20;
    const _height = height ?? 14;

    return (
        <svg
            width={_width}
            height={_height}
            viewBox="0 0 20 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="fill-black dark:fill-white"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.2929 13.7071C6.6834 14.0976 7.3166 14.0976 7.7071 13.7071C8.0976 13.3166 8.0976 12.6834 7.7071 12.2929L3.4142 8L19 8C19.5523 8 20 7.5523 20 7C20 6.4477 19.5523 6 19 6L3.4142 6L7.7071 1.7071C8.0976 1.3166 8.0976 0.683401 7.7071 0.292901C7.3166 -0.0975992 6.6834 -0.0975992 6.2929 0.292901L0.292901 6.2929C-0.0975984 6.6834 -0.0975984 7.3166 0.292901 7.7071L6.2929 13.7071Z"
            />
        </svg>
    );
};
